/**
 * CMS key for subscription-faqs / highlights / info / features.
 * Iconic Pro available → iconic-pro-{goalUid}, else → iconic-{goalUid}.
 */
const getSubscriptionCmsKey = (goalUid, isIconicProAvailable = false) =>
  isIconicProAvailable ? `iconic-pro-${goalUid}` : `iconic-${goalUid}`;

export default getSubscriptionCmsKey;
